<template>
    <div class="wxSend wxNoscroll">
        <h3>{{title}}</h3>
        <Row>
            <li v-for="(item,index) in mealList" :key="index">
                时间：{{item.meal_date}}<br />
                招待部门：{{item.receive_department}}<br />
                <Button @click="toLink(item.id)" type="primary">修改</Button>
                <Button @click="removeList(item)" type="error">删除</Button>
            </li>
            <Modal
                v-model="modal1"
                @on-ok="ok">
                <p>是否删除</p>
            </Modal>
            <div>{{showIt}}</div>
            <wxNav></wxNav>
        </Row>
    </div>
</template>


<script>
    import wxNav from "../wxNav"
    export default {
        props: ["wxCode"],
        data () {
          return{
                mealList:[],
                modal1: false,
                showIt:{},
                formInline: {
                    username: "",
                    realname: 'test',
                    meal_date: "",
                    meal_type:"breakfast",
                    department:"",
                    receive_name:"",
                    receive_department:"",
                    guests_count : null
                },
                departmentList:[],
                currentItem :{}
            }
        },
        components:{
            wxNav
        },
        methods:{
            //获得人员信息
            getPeople(){
                let params = {};
                var that = this;
                params.data = {
                    searchValue: {
                        "xcx_openId": this.wxCode
                    },
                    order: {
                        "_id" : -1
                    }
                };
                params.url = "/sys/userinfo/list";
                params.token = "swgykj9527";
                params.success = function(res) {
                   that.formInline.username = res.data.result.result[0].username;
                   that.formInline.realname = res.data.result.result[0].realname;
                   that.getMealList();
                };
                this.ajaxPostWX(params);
            },
            toLink(id){
                this.$router.push("/data/wxEditEnter/"+id);
            },
            //获得接待列表
            getMealList(){
                var that = this;
                let params = {};
                params.data = {
                    searchValue: {
                        "username": that.formInline.username
                    }
                }
                params.url = "/sys/mealentertain/list";
                params.token = "swgykj9527";
                params.success = function(res) {
                    that.mealList = res.data.result.result
                };
                that.ajaxPostWX(params);
            },
            removeList(item) {
                this.modal1 = true;
                this.currentItem  = item;
            },
            ok(){
                var that = this;
                let params = {};
                params.data = this.currentItem;
                params.url = "/sys/mealentertain/delete";
                params.token = "swgykj9527";
                params.success = function(res) {
                    if(res.data.code == "0000"){
                        that.$Message.success(res.data.message);
                        that.getMealList();
                    }else{
                        that.$Message.error(res.data.message);
                    }
                };
                that.ajaxPostWX(params);
            }
        },
        mounted: function() {
            this.getPeople();
        }
    }
</script>

<style lang="scss">
    .wxSend{
        max-width: 768px;
        margin: 0 auto;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/dinnerMana/wxEnterList.vue